import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, catchError, of, throwError } from 'rxjs';
import { AuthService } from './auth.service';
import { Router, RouterStateSnapshot } from '@angular/router';
import { LoaderService } from 'src/app/services/loader.service';
import { ToastrService } from 'ngx-toastr';
import { ErrorHandlerService } from '../error-handler/error-handler.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService,private router: Router,private loaderService: LoaderService, private toastr: ToastrService
    ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.authService.getToken();

    if (token) {
      // Clone the request and add the Authorization header with the token
      const authRequest = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      });

      return next.handle(authRequest).pipe(
        catchError((error: HttpErrorResponse) => {
          if (error.status === 401) {
            this.handle401(error);
          }
          else if (error.status === 404){
            this.handle404(error);
          }
          else {
            // error.error is a ProgressEvent for network failures and an object for
            // JSON bodies; normalise to text so the toast never reads "[object …]".
            const message = ErrorHandlerService.toMessage(error);
            if (message) {
              this.toastr.error(message);
            }
            this.loaderService.setLoading(false);
          }
          return throwError(() => error);
        })
      );
    }

    // If there's no token, proceed with the original request
    return next.handle(request);
  }

  private handle401(error){
    this.authService.logout();
     this.router.navigate(['/'], { queryParams: { returnUrl: this.router.url } });
    if(this.router.url){
      this.authService.updateReturnURL(this.router.url);
    }
    // A 401 can arrive with an empty body; the old `error.error.message` threw then.
    this.toastr.error(ErrorHandlerService.bodyMessage(error) || 'Your session has expired. Please sign in again.');
    this.loaderService.setLoading(false);
  }

  private handle404(error){
    this.loaderService.setLoading(false);
    this.toastr.error("Something Went Wrong!!");
    return throwError(() => error);
  }
}
